import axios from 'axios';

// const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';
//
const API_BASE_URL = 'https://uzsport-api.teamora.uz';
// const API_BASE_URL = 'http://localhost:8080';

function bearerFromConfig(config) {
  const auth = config?.headers?.Authorization;
  if (typeof auth !== 'string' || !auth.startsWith('Bearer ')) return null;
  return auth.slice(7).trim();
}

/** 401 used an older token than is now in storage (e.g. login replaced token while requests were in flight). */
function isStaleUnauthorized(error) {
  const used = bearerFromConfig(error.config);
  const current = localStorage.getItem('token');
  return Boolean(used && current && used !== current);
}

/**
 * Admin sidebar fires many parallel GET .../list calls for badges. If some return 401 while the session
 * is still valid, do not clear storage or redirect — that was logging users out immediately after login.
 */
function isIgnorableListCount401(error) {
  const cfg = error.config;
  if (!cfg || (cfg.method || 'get').toLowerCase() !== 'get') return false;
  const path = `${cfg.baseURL || ''}${cfg.url || ''}`.split('?')[0];
  return /\/api\/v1\/[^/]+\/list$/.test(path);
}

function shouldSkipSessionTeardownOn401(error) {
  return isStaleUnauthorized(error) || isIgnorableListCount401(error);
}

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    const lang = localStorage.getItem('i18nextLng') || 'uz';
    config.headers['Accept-Language'] = lang;
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    if (status === 401 && !shouldSkipSessionTeardownOn401(error)) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      if (window.location.pathname.startsWith('/admin')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
